const Refresh = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.5 16.5C10.5 16.5 11.1369 16.409 13.773 13.773C16.409 11.1369 16.409 6.86307 13.773 4.22703C12.839 3.29307 11.6995 2.69002 10.5 2.41787M10.5 16.5H15M10.5 16.5L10.5 12M7.5 1.50015C7.5 1.50015 6.86307 1.59114 4.22703 4.22718C1.59099 6.86322 1.59099 11.1371 4.22703 13.7731C5.16099 14.7071 6.30054 15.3101 7.5 15.5823M7.5 1.50015L3 1.5M7.5 1.50015L7.5 6"
      stroke="#6D28D9"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Refresh;
